import { useTranslation } from 'react-i18next'
import { useAccount } from '@/hooks/useAccount'

export default function ErrorPage() {
  const { t } = useTranslation('common')
  const { error } = useAccount()

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-200 p-6">
      <div className="text-center max-w-sm">
        <div className="text-6xl mb-4">⚠️</div>
        <h1 className="text-xl font-bold text-error mb-2">
          {t('errors.liff_not_configured')}
        </h1>
        {error && (
          <p className="text-base-content/70 text-sm mt-2">{error}</p>
        )}
      </div>
    </div>
  )
}
